export const LOADING = "_LOADING"
export const LOADED = "_LOADED"
export const ERROR = "_ERROR"
